import { useContext } from "react";
import { useTranslation } from "react-i18next";
import AlertDefault from "~/src/components/Alerts/AlertDefault";
import BottomLine from "~/src/components/BottomLine";
import Switch from "~/src/components/Form/Switch";
import Text from "~/src/components/Text/Text";
import { useFormDataContext } from "~/src/contexts/FormDataContext/FormDataContext";
import { IndividFormDataContext } from "~/src/pages/Registrering/components/IndividForm";
import { AccordionDefault } from "../../../components/Accordion/AccordionDefault";
import InputDefault from "../../../components/Form/Input/InputDefault";
import AppDataContext from "../../../contexts/AppDataContext/DataProvider";
import { ArtType } from "../../../helpers/types";

export default function KvitteringsKopi(): JSX.Element {
  const { t } = useTranslation();
  const { formData, formErrors, setFormData } = useFormDataContext(IndividFormDataContext);
  const { KvitteringEgen, KvitteringJaktleder, KvitteringValdansvarlig, KvitteringAnnen } =
    formData;
  const { jegeropplysninger } = useContext(AppDataContext);

  const setKvitteringValdansvarlig = (sendKvittering: boolean) =>
    setFormData({ ...formData, KvitteringValdansvarlig: sendKvittering });
  const setKvitteringAnnen = (epost: string) =>
    setFormData({ ...formData, KvitteringAnnen: epost ? epost : undefined });
  const setKvitteringEgen = (sendKvittering: boolean) =>
    setFormData({ ...formData, KvitteringEgen: sendKvittering });
  const setKvitteringJaktleder = (sendKvittering: boolean) =>
    setFormData({ ...formData, KvitteringJaktleder: sendKvittering });

  return (
    <AccordionDefault
      title={t("pages.registrerArt.epostBekreftelse.title")}
      defaultOpen={false}
      error={formErrors?.KvitteringAnnen ? true : false}
    >
      <fieldset>
        <legend className="text-xl font-bold mb-1 ml-4">
          {t("pages.registrerArt.epostBekreftelse.subHeader")}
        </legend>
        <div className="gap-y-1">
          <Switch
            label={t("pages.registrerArt.epostBekreftelse.valdansvarlig")}
            checked={KvitteringValdansvarlig ?? false}
            onChange={() => setKvitteringValdansvarlig(!KvitteringValdansvarlig)}
          />
          {[ArtType.Hjort, ArtType.Elg].includes(formData.Art) && (
            <Switch
              label={t("pages.registrerArt.epostBekreftelse.jaktleder")}
              checked={KvitteringJaktleder ?? false}
              onChange={() => setKvitteringJaktleder(!KvitteringJaktleder)}
            />
          )}
          <Switch
            label={
              t("pages.registrerArt.epostBekreftelse.meg") +
              (!jegeropplysninger.data?.Epost ? "*" : "")
            }
            checked={KvitteringEgen ?? false}
            onChange={() => setKvitteringEgen(!KvitteringEgen)}
            disabled={!jegeropplysninger.data?.Epost}
          />
          <BottomLine />
          {!jegeropplysninger.data?.Epost && (
            <AlertDefault>{t("pages.registrerArt.epostBekreftelse.helperText")}</AlertDefault>
          )}
        </div>
      </fieldset>

      <div className="w-full pt-4">
        <InputDefault
          id={"input-kvitteringskopi-annenEpost"}
          label={t("pages.registrerArt.epostBekreftelse.annenEpostLabel")}
          placeholder={t("pages.registrerArt.epostBekreftelse.annenEpostPlaceholder")}
          onValueChanged={(value) => setKvitteringAnnen(value)}
          defaultValue={KvitteringAnnen ?? ""}
          validationErrorMessage={formErrors?.KvitteringAnnen}
        />
      </div>
    </AccordionDefault>
  );
}
